// PostList.jsx
import React, { JSX, useEffect, useMemo, useState } from 'react';
import { Ads, Post as PostType } from '../../../types';
import "./style.css"
import Post from '../Post/Post';
import RepostWithText from '../../Modals/RepostWithText';
import EditPost from '../../Modals/EditPost';
import ConfirmationModal from '../../Modals/ConfirmationModal';
import { useAuth } from '../../../global-components/src';
import axios from 'axios';
import { LIMIT_TEXT_REPORT } from '../../../utils/vars';
import { useMessage } from '../../../global-components/src';
import ReportModal from '../../Modals/Report';
import { errorMessage } from '../../../utils/TextManagerTwo';
import { PACOCA_API_URL } from '../../../global-components/src/utils/vars';
import { Virtuoso } from 'react-virtuoso';
import { useTranslation } from 'react-i18next';
import AdsterraAdSlot from '../../adsterra-ads/adsterra-ad-slot';
import GoogleAdSlot from '../../google-ads/google-ad-slot';
import {
    ADSTERRA_AD_INTERVAL,
    getFeedAdProvider,
    isAdsterraFeedConfigured,
} from '../../../utils/adsterra-ads';
import { GOOGLE_AD_INTERVAL, isGoogleAdConfigured } from '../../../utils/google-ads';

interface PostListProps {
    posts: PostType[] | Ads[]; // Define que posts é um array de Post
    setPosts?: React.Dispatch<React.SetStateAction<PostType[]>>; // Permite função de atualização
    onCloseModals?: () => void; // Permite função de atualização
    onOpenLikes?: (idPost: number) => void; // Permite função de atualização
    onOpenComments?: (idPost: number) => void; // Permite função de atualização
    feedInnerRef?: React.RefObject<HTMLDivElement | null>;
    showFollowUser?: boolean;
    googleAds?: boolean;
}

const PostList: React.FC<PostListProps> = ({ posts, setPosts, onOpenLikes, onOpenComments, onCloseModals, feedInnerRef, showFollowUser, googleAds = false }) => {
    const [repostPostId, setRepostPostId] = useState<number | null>(null);
    const [reportIdUser, setReportIdUser] = useState<number | null>(null);
    const [reportIdPost, setReportIdPost] = useState<number | null>(null);
    const [post, setPost] = useState<PostType | null>(null);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [showConfirmationRestore, setShowConfirmationRestore] = useState(false);
    const [postToDelete, setPostToDelete] = useState<PostType | null>(null);
    const [password, setPassword] = useState(''); // Adicione um estado para a senha
    const [reasonDeletePost, setReasonDeletePost] = useState(''); // Adicione um estado para a senha
    const [errorModal, setErrorModalPassword] = useState(''); // Adicione um estado para a senha
    const [isLoading, setIsLoading] = useState(false); // Adicione um estado para a senha
    const { user, token } = useAuth()
    const { setMessage } = useMessage();
    const { t } = useTranslation();
    const [isLimitExceeded, setIsLimitExceeded] = useState(false);
    const [unavailableFeedAds, setUnavailableFeedAds] = useState<Set<string>>(
        () => new Set(),
    );
    const feedAdProvider = getFeedAdProvider();
    const isFeedAdConfigured =
        googleAds &&
        (feedAdProvider === 'adsterra'
            ? isAdsterraFeedConfigured()
            : isGoogleAdConfigured('feed'));
    const feedAdInterval =
        feedAdProvider === 'adsterra' ? ADSTERRA_AD_INTERVAL : GOOGLE_AD_INTERVAL;

    const displayItems = useMemo(() => {
        if (!googleAds || !isFeedAdConfigured) return posts;

        const items: Array<
            (typeof posts)[number] | { kind: 'google-ad' | 'adsterra-ad'; key: string }
        > = [];
        let organicPostsSinceLastAd = 0;

        posts.forEach((item, index) => {
            items.push(item);

            const post = React.isValidElement(item) ? undefined : (item as PostType);
            if (!post || post.ads) return;

            organicPostsSinceLastAd += 1;
            const nextPost = posts[index + 1] as PostType | undefined;
            const hasPublisherContentAfter = index < posts.length - 1 && !nextPost?.ads;
            if (organicPostsSinceLastAd < feedAdInterval || !hasPublisherContentAfter) {
                return;
            }

            const key = `${feedAdProvider}-feed-ad-${post.id}`;
            if (!unavailableFeedAds.has(key)) {
                items.push({ kind: `${feedAdProvider}-ad`, key });
            }
            organicPostsSinceLastAd = 0;
        });

        return items;
    }, [
        feedAdInterval,
        feedAdProvider,
        googleAds,
        isFeedAdConfigured,
        posts,
        unavailableFeedAds,
    ]);

    const isFeedAdItem = (
        item: (typeof displayItems)[number],
    ): item is { kind: 'google-ad' | 'adsterra-ad'; key: string } =>
        !React.isValidElement(item) &&
        typeof item === 'object' &&
        item !== null &&
        'kind' in item &&
        (item.kind === 'google-ad' || item.kind === 'adsterra-ad');

    const handleDeletePost = (post: PostType) => {
        setPassword("");
        setErrorModalPassword("");
        setPostToDelete(post);
        setShowConfirmation(false);
        setShowConfirmation(true);
    };

    const handleRestorePost = (post: PostType) => {
        setPassword("");
        setErrorModalPassword("");
        setPostToDelete(post);
        setShowConfirmationRestore(false);
        setShowConfirmationRestore(true);
    };

    const onClose = () => {
        setPassword("");
        setPostToDelete(null);
        setShowConfirmation(true)
        setShowConfirmation(false)
    }

    const onCloseRestore = () => {
        setPassword("");
        setPostToDelete(null);
        setShowConfirmationRestore(true)
        setShowConfirmationRestore(false)
    }

    const confirmDelete = async (password: string) => {
        const url = PACOCA_API_URL + `/posts/${postToDelete?.id}`;
        setErrorModalPassword("")
        setIsLoading(true);

        let removedPost = postToDelete;
        try {
            if (user?.id !== postToDelete?.id_user && !password) {
                setErrorModalPassword("Informe sua senha")
                setIsLoading(false)
                return;
            }
            if (user?.id !== postToDelete?.id_user && !reasonDeletePost) {
                setErrorModalPassword("Informe o motivo")
                setIsLoading(false)
                return;
            }
            if (user?.id !== postToDelete?.id_user && (reasonDeletePost?.length <= 2 || reasonDeletePost?.toLowerCase() == "regras" || reasonDeletePost?.toLowerCase() == "regra")) {
                setErrorModalPassword("Explique melhor o motivo")
                setIsLoading(false)
                return;
            }

            await axios.delete(url, {
                params: { password, id_post: postToDelete?.id, reason: reasonDeletePost }, // Passa a senha dentro do objeto `data`
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            });

            if (postToDelete && setPosts) {
                setPosts(prevPosts => {
                    let removedPost = null;
                    const newPosts = prevPosts.filter(p => {
                        const isMatch = p.id === postToDelete.id;
                        const isRepost = p.original_post?.id === postToDelete.id;

                        if (isMatch) removedPost = p;

                        // remove se for o post em si ou um repost com esse original_post
                        return !isMatch && !isRepost;
                    });

                    return newPosts;
                });
            }

            setShowConfirmation(false)
            setMessage(t("post.deleted"), "success");
            setPassword("");
        } catch (err: any) {
            const messageError = errorMessage(err);
            setErrorModalPassword(messageError)
        } finally {
            setIsLoading(false)
        }
    };

    const confirmRestore = async (password: string) => {
        const url = PACOCA_API_URL + `/posts/restore/${postToDelete?.id}`;
        setErrorModalPassword("")
        setIsLoading(true);

        let removedPost = postToDelete;
        try {
            if (user?.id !== postToDelete?.id_user && !password) {
                setErrorModalPassword("Informe sua senha")
                setIsLoading(false)
                return;
            }
            if (user?.id !== postToDelete?.id_user && !reasonDeletePost) {
                setErrorModalPassword("Informe o motivo")
                setIsLoading(false)
                return;
            }
            if (user?.id !== postToDelete?.id_user && (reasonDeletePost?.length <= 2 || reasonDeletePost?.toLowerCase() == "regras" || reasonDeletePost?.toLowerCase() == "regra")) {
                setErrorModalPassword("Explique melhor o motivo")
                setIsLoading(false)
                return;
            }

            await axios.post(url, { password, id_post: postToDelete?.id, reason: reasonDeletePost }, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            });

            if (postToDelete && setPosts) {
                setPosts(prevPosts => {
                    let removedPost = null;
                    const newPosts = prevPosts.filter(p => {
                        const isMatch = p.id === postToDelete.id;
                        const isRepost = p.original_post?.id === postToDelete.id;

                        if (isMatch) removedPost = p;

                        // remove se for o post em si ou um repost com esse original_post
                        return !isMatch && !isRepost;
                    });

                    return newPosts;
                });
            }

            setShowConfirmationRestore(false)
            setMessage(t("post.restored"), "success");
            setPassword("");
        } catch (err: any) {
            const messageError = errorMessage(err);
            setErrorModalPassword(messageError)
        } finally {
            setIsLoading(false)
        }
    };

    const updatePostReportStatus = (id_post: number, wasReported: boolean) => {
        if (!setPosts) return;

        setPosts(prevPosts =>
             prevPosts.map(p =>
                p.id === id_post ? { ...p, reported: wasReported } : p
            )
        );
    };

    // Função para atualizar o estado de follow em um post específico
    const updatePostFollowStatus = (isFollowing: boolean, idUser: number) => {
        if(!setPosts) return;

        setPosts(prevPosts => 
            prevPosts.map(post => {
            // Se o post for do usuário que foi seguido/deseguido
            if (post.user?.id === idUser) {
                return {
                ...post,
                is_following: isFollowing
                };
            }
            return post;
            })
        );
    };

    return (
        <div style={{ overflow: "hidden" }}>
            {/* {posts.length > 0 ? (
                <div ref={feedInnerRef}>
                    {posts.map((item, idx) => {
                        // If it's a JSX.Element, render it directly
                        if (React.isValidElement(item)) {
                            return React.cloneElement(item, { key: item.key ?? idx });
                        }
                        // Otherwise, assume it's a PostType
                        const post = item as PostType;
                        
                        if (post && typeof post === "object" && "id" in post) {
                            return (
                                <Post
                                    onFollow={updatePostFollowStatus}
                                    showFollowUser={showFollowUser}
                                    onCloseModals={() => onCloseModals ? onCloseModals() : () => {}}
                                    onOpenComments={() => onOpenComments ? onOpenComments(post.id) : () => {}}
                                    onOpenLikes={() => onOpenLikes ? onOpenLikes(post.id) : () => {}}
                                    key={post.id}
                                    post={post}
                                    onRepost={() => setRepostPostId(post.original_post_id ? post.original_post_id : post.id)}
                                    onEdit={(postP) => setPost(postP)}
                                    onDelete={(postP) => handleDeletePost(postP)}
                                    onRestore={(postP) => handleRestorePost(postP)}
                                    onReport={(removeReport, id_user, id_post) => {
                                        setReportIdUser(id_user)
                                        setReportIdPost(id_post)
                                        if(removeReport)
                                            updatePostReportStatus(id_post, false)
                                    }}
                                />
                            );
                        }
                        // If neither, render nothing
                        return null;
                    })}
                </div>
            ) : (
                <></>
            )} */}
            {posts.length > 0 && (
                <Virtuoso
                    defaultItemHeight={400}
                    useWindowScroll
                    overscan={200}
                    increaseViewportBy={{ top: 600, bottom: 600 }}
                    totalCount={displayItems.length}
                    computeItemKey={(index) => {
                        const item = displayItems[index];
                        if (isFeedAdItem(item)) return item.key;
                        return React.isValidElement(item) ? index : item.id;
                    }}
                    itemContent={(index) => {
                        const item = displayItems[index];

                        if (isFeedAdItem(item)) {
                            const markAsUnavailable = () => {
                                setUnavailableFeedAds(current => {
                                    if (current.has(item.key)) return current;
                                    const next = new Set(current);
                                    next.add(item.key);
                                    return next;
                                });
                            };

                            return item.kind === 'adsterra-ad' ? (
                                <AdsterraAdSlot onError={markAsUnavailable} />
                            ) : (
                                <GoogleAdSlot
                                    placement="feed"
                                    onUnfilled={markAsUnavailable}
                                />
                            );
                        }

                        if (React.isValidElement(item)) {
                            return React.cloneElement(item, { key: item.key ?? index });
                        }

                        const post = item as PostType;

                        if (post && typeof post === "object" && "id" in post) {
                            return (
                            <Post
                                key={post.id}
                                post={post}
                                setPosts={setPosts}
                                onFollow={updatePostFollowStatus}
                                showFollowUser={showFollowUser}
                                onCloseModals={() => onCloseModals ? onCloseModals() : () => {}}
                                onOpenComments={() => onOpenComments ? onOpenComments(post.id) : () => {}}
                                onOpenLikes={() => onOpenLikes ? onOpenLikes(post.id) : () => {}}
                                onRepost={() =>
                                setRepostPostId(
                                    post.original_post_id ? post.original_post_id : post.id
                                )
                                }
                                onEdit={(postP) => setPost(postP)}
                                onDelete={(postP) => handleDeletePost(postP)}
                                onRestore={(postP) => handleRestorePost(postP)}
                                onReport={(removeReport, id_user, id_post) => {
                                setReportIdUser(id_user);
                                setReportIdPost(id_post);
                                if (removeReport)
                                    updatePostReportStatus(id_post, false);
                                }}
                            />
                            );
                        }
                        return null;
                    }}
                />
            )}
            <RepostWithText id_post={repostPostId} />
            <EditPost
                onEdit={(newText, gifUrl) => {
                    if (setPosts) {
                        setPosts((prevPosts) =>
                            prevPosts.map((p) => {
                                    // Se houver original_post, edita lá também
                                    if (p?.original_post?.id == post?.id) {
                                        return {
                                            ...p,
                                            original_post: {
                                                ...p.original_post,
                                                text: newText,
                                                gif_url: gifUrl ?? null,
                                            }
                                        };
                                    }

                                    // Caso contrário, edita o próprio post
                                    if (p.id === post?.id) {
                                        return {
                                            ...p,
                                            text: newText,
                                            gif_url: gifUrl ?? null,
                                        };
                                    }

                                return p;
                            })
                        );
                    }
                }}
                post={post}
            />



            <ConfirmationModal
                show={showConfirmation}
                onClose={() => onClose()}
                onConfirm={() => confirmDelete(password)} // Passa a senha aqui
                post={postToDelete}
                title='Excluir Post'
                coverMobile={postToDelete?.id_user != user?.id}
                text={t('post.confirmDelete')}
                requirePassword={postToDelete?.id_user != user?.id}
                setPassword={setPassword} // Adicione a função setPassword aqui
                errorMessage={errorModal}
                isLoading={isLoading}
                extraContent={
                    <>
                        {postToDelete?.id_user != user?.id ? (
                            <>
                                <textarea
                                    placeholder='Motivo'
                                    value={reasonDeletePost}
                                    onChange={(e) => setReasonDeletePost(e.target.value)}
                                    className={`mt-3 form-control`}
                                    name="text"
                                    style={{ color: isLimitExceeded ? "red" : "inherit" }}
                                    cols={30} rows={10} />

                                <div className="user-select-none limite-denuncia">
                                    {reasonDeletePost?.length}/{LIMIT_TEXT_REPORT}
                                </div>
                            </>
                        ) : null}
                    </>
                } />

            <ConfirmationModal
                idModal='restore-post'
                show={showConfirmationRestore}
                onClose={() => onCloseRestore()}
                onConfirm={() => confirmRestore(password)} // Passa a senha aqui
                post={postToDelete}
                title='Restaurar Post'
                coverMobile={postToDelete?.id_user != user?.id}
                text={t('post.confirmRestore')}
                requirePassword={postToDelete?.id_user != user?.id}
                setPassword={setPassword} // Adicione a função setPassword aqui
                errorMessage={errorModal}
                isLoading={isLoading}
                extraContent={
                    <>
                        {postToDelete?.id_user != user?.id ? (
                            <>
                                <textarea
                                    placeholder='Motivo'
                                    value={reasonDeletePost}
                                    onChange={(e) => setReasonDeletePost(e.target.value)}
                                    className={`mt-3 form-control`}
                                    name="text"
                                    style={{ color: isLimitExceeded ? "red" : "inherit" }}
                                    cols={30} rows={10} />

                                <div className="user-select-none limite-denuncia">
                                    {reasonDeletePost?.length}/{LIMIT_TEXT_REPORT}
                                </div>
                            </>
                        ) : null}
                    </>
                } />

            <ReportModal onUpdateReportStatus={updatePostReportStatus} id_user={reportIdUser} id_post={reportIdPost} />
        </div>
    );
};

export default PostList;
